













  import Vue from 'vue';

  export default Vue.extend({
    name: "ValueEditWidget",
    props: {
      config: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        localConfig: this.config
      }
    }
});
